
export enum ServiceStatusCd {
	EXEMPT = 'Exempt',
	FAIL = 'Fail',
	SUCCESS = 'Success',
	UNKNOWN = 'Unknown'}

